/**
 * Lookup-table resolution — sheet_data half-open bucket search with default
 * index length-1, first-hit break, and the practically-unreachable index-0
 * overflow snap (REQ-FORM-6; research/04 §2.6). Moved verbatim from the
 * FormulaParser tail of the Phase-2 single-file port
 * (pricing/price-calculation.ts) and from formula/safe-regex.ts
 * (getCurrentElementDataByIdenfier — the typo'd export name is v1's,
 * FORM-019).
 *
 * A missing `sheet_data` throws here (`reading 'input1_range'`) and is
 * caught by FormulaParser's catch → reported → 'NaN' value (ERRATA #5).
 */
import { appState } from "../state/app-state";
import { generateSafeRegex } from "./safe-regex";

export function getCurrentElementDataByIdenfier(identifier: any): any {
  var allelements = appState.cpc_data.Elements;
  var finalElement: any = null;
  allelements.forEach((element: any) => {
    if (element.Identifier === identifier) {
      finalElement = element;
    }
  });
  return finalElement;
}

export function resolveLookupTables(formula: any, lookupElements: any): any {
  for (var key in lookupElements) {
    let currentLookupElementData = lookupElements[key];
    var elementData = getCurrentElementDataByIdenfier(key);

    //Replace sub elements
    let lookupElementIdentifier1 =
      currentLookupElementData["elementName"] +
      "[" +
      currentLookupElementData["input1_label"] +
      "]";
    let lookupElementIdentifier2 =
      currentLookupElementData["elementName"] +
      "[" +
      currentLookupElementData["input2_label"] +
      "]";
    let regexPattern = generateSafeRegex(lookupElementIdentifier1);
    formula = formula.replace(
      regexPattern,
      currentLookupElementData["input1"],
    );
    regexPattern = generateSafeRegex(lookupElementIdentifier2);
    formula = formula.replace(
      regexPattern,
      currentLookupElementData["input2"],
    );

    let xIndex = elementData.sheet_data.input1_range.length - 1;
    let yIndex = elementData.sheet_data.input2_range.length - 1;
    for (
      let step = 0;
      step < elementData.sheet_data.input1_range.length - 1;
      step++
    ) {
      if (
        parseFloat(currentLookupElementData.input1) >=
        parseFloat(elementData.sheet_data.input1_range[step]) &&
        parseFloat(currentLookupElementData.input1) <
        parseFloat(elementData.sheet_data.input1_range[step + 1])
      ) {
        xIndex = step;
        break;
      }
    }
    for (
      let step = 0;
      step < elementData.sheet_data.input2_range.length - 1;
      step++
    ) {
      if (
        parseFloat(currentLookupElementData.input2) >=
        parseFloat(elementData.sheet_data.input2_range[step]) &&
        parseFloat(currentLookupElementData.input2) <
        parseFloat(elementData.sheet_data.input2_range[step + 1])
      ) {
        yIndex = step;
        break;
      }
    }

    //If the input is greater than the range then take the last element
    if (
      xIndex === 0 &&
      parseFloat(currentLookupElementData.input1) >
      parseFloat(
        elementData.sheet_data.input1_range[
        elementData.sheet_data.input1_range.length - 1
        ],
      )
    ) {
      xIndex = elementData.sheet_data.input1_range.length - 1;
    }
    //If the input is greater than the range then take the last element
    if (
      yIndex === 0 &&
      parseFloat(currentLookupElementData.input2) >
      parseFloat(
        elementData.sheet_data.input2_range[
        elementData.sheet_data.input2_range.length - 1
        ],
      )
    ) {
      yIndex = elementData.sheet_data.input2_range.length - 1;
    }

    let value = elementData.sheet_data.data_lookup[yIndex][xIndex];
    regexPattern = generateSafeRegex(key);
    formula = formula.replace(regexPattern, value);
  }

  return formula;
}
